module.exports = __webpack_public_path__ + "assets/7d4c696622ac74b3f0f5403434ebf252.mp3";